import { formatDate } from '@progress/kendo-intl';
import { useCallback } from 'react';
import uuid from 'react-uuid';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';
import { removeTime } from 'src/utils/formatTime';
import { convertDate } from 'src/utils/transformation';

interface IPostBody {
  glCodeId: number;
  glPeriodId: number;
}

export interface ICommittedAmountTransaction {
  rowId: string;
  expanded: boolean;
  transactionDate: string;
  date: Date;
  actualDate: Date;
  user: string;
  documentNumber: string;
  poId: number;
  action: string;
  total: number;
  comments: string;
  notes: string;
  balance: number;
  budgetAmt: number;
  forecast: number;
  glCode: string;
  invoiceId: number;
  invoiceNumber: string;
  items: [
    {
      lineItem: string;
      itemNum: string;
      description: string;
      amount: number;
    }
  ];
}

const useCommittedAmountApi = () => {
  const call = useCallback(
    (body?: IPostBody) =>
      new Promise<ICommittedAmountTransaction[]>((resolve, reject) => {
        axiosInstance
          .get<ICommittedAmountTransaction[]>(
            api.getCommittedAmount(body?.glCodeId as number, body?.glPeriodId as number)
          )
          .then((data) => {
            const res = data.data.map((item) => {
              const date = convertDate(item.transactionDate);

              return {
                ...item,
                rowId: uuid(),
                expanded: false,
                transactionDate: formatDate(date, 'MM/dd/yyyy h:mm:ss a'),
                date: removeTime(date),
                actualDate: date,
              };
            });
            return resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    []
  );

  const { execute, isLoading } = useAsync(call, false);

  return {
    getCommittedAmountTransaction: execute,
    isCommittedLoading: isLoading,
  };
};

export default useCommittedAmountApi;
